import { Link } from "react-router-dom";
import { Clock, Users, ArrowRight } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { inr, fileUrl } from "@/lib/api";

export function TaskCard({ task, index = 0 }) {
  return (
    <div data-testid={`task-card-${task.task_code}`} className="bg-white rounded-2xl border border-slate-200/80 shadow-[0_2px_10px_-3px_rgba(15,23,42,0.06)] hover:shadow-[0_10px_25px_-5px_rgba(15,23,42,0.1)] transition-shadow duration-200 p-5 sm:p-6 flex flex-col animate-fade-up" style={{ animationDelay: `${index * 60}ms` }}>
      <div className="flex items-start gap-4">
        <img src={fileUrl(task.app_logo) || "https://ui-avatars.com/api/?name=" + encodeURIComponent(task.app_name) + "&background=2563EB&color=fff&size=96"} alt={task.app_name} data-testid={`task-logo-${task.task_code}`} className="w-14 h-14 rounded-2xl object-cover border border-slate-200 shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-heading font-semibold text-slate-900 text-lg truncate">{task.app_name}</h3>
            <StatusBadge status={task.status} testid={`task-status-${task.task_code}`} />
          </div>
          <p className="text-xs font-medium text-slate-500 mt-0.5" data-testid={`task-id-${task.task_code}`}>{task.task_code}</p>
        </div>
      </div>
      <p className="mt-3 text-sm text-slate-600 leading-relaxed line-clamp-2">{task.description}</p>
      <div className="mt-4 grid grid-cols-3 gap-2 text-center">
        <div className="bg-slate-50 rounded-xl py-2.5 px-1">
          <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wide">Reward</p>
          <p className="text-base font-bold text-blue-700 font-heading" data-testid={`task-reward-${task.task_code}`}>{inr(task.reward)}</p>
        </div>
        <div className="bg-slate-50 rounded-xl py-2.5 px-1">
          <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wide flex items-center justify-center gap-1"><Clock className="w-3 h-3" />Time</p>
          <p className="text-sm font-semibold text-slate-800">{task.estimated_time}</p>
        </div>
        <div className="bg-slate-50 rounded-xl py-2.5 px-1">
          <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wide flex items-center justify-center gap-1"><Users className="w-3 h-3" />Slots</p>
          <p className="text-sm font-semibold text-slate-800" data-testid={`task-slots-${task.task_code}`}>{task.participants_remaining} left</p>
        </div>
      </div>
      <Link to={`/tasks/${task.task_code}`} data-testid={`view-task-btn-${task.task_code}`} className="mt-5 inline-flex items-center justify-center gap-2 w-full px-5 py-3 rounded-xl font-semibold text-white bg-blue-600 hover:bg-blue-700 active:bg-blue-800 transition-colors shadow-sm">
        View Task <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
